export default function Footer() {
    return (
        <div className="footer">
            <a href="terms.html" target="_blank">
                Terms and conditions
            </a>
        </div>
    )
}
